export default __webpack_public_path__ + "static/media/aster.d6e0996d.svg";